import { Box } from '@chakra-ui/react';
import { ChoosePlatform } from '@/components/Templates/ChoosePlatform';

const ChoosePlatformPage = () => {
	return (
		<Box>
			<ChoosePlatform />
		</Box>
	);
};

export default ChoosePlatformPage;
